import { AlertTriangle } from "lucide-react";
import { formatDate, formatMXN } from "@/lib/utils";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import type { FacturaVencidaItem } from "./schemas";

type Props = {
  items: FacturaVencidaItem[];
  total: number;
  monto: number;
};

/**
 * Sección de facturas vencidas del cliente (F14.4).
 * Muestra hasta 10 facturas; si hay más, indica el delta para ir a la tab de facturas.
 */
export function ClienteFacturasVencidasSection({ items, total, monto }: Props) {
  if (items.length === 0) return null;
  const extra = total - items.length;

  return (
    <section className="rounded-lg border border-destructive/30 bg-destructive/5 p-3">
      <div className="mb-2 flex items-center gap-2 text-destructive">
        <AlertTriangle size={14} />
        <h3 className="text-sm font-semibold">
          {total} {total === 1 ? "factura vencida" : "facturas vencidas"} ·{" "}
          {formatMXN(monto)}
        </h3>
      </div>
      <div className="rounded-md border bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Folio</TableHead>
              <TableHead>Emisión</TableHead>
              <TableHead>Vencimiento</TableHead>
              <TableHead>Días</TableHead>
              <TableHead className="text-right">Saldo</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {items.map((f) => (
              <TableRow key={f.id}>
                <TableCell className="font-mono">{f.folio}</TableCell>
                <TableCell>{formatDate(f.fecha_emision)}</TableCell>
                <TableCell>{formatDate(f.fecha_vencimiento)}</TableCell>
                <TableCell>
                  <Badge variant="destructive">{f.dias_atraso}d</Badge>
                </TableCell>
                <TableCell className="text-right font-medium">
                  {formatMXN(Number(f.saldo))}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      {extra > 0 && (
        <p className="mt-2 text-[11px] text-muted-foreground">
          +{extra} más · se mostrarán todas en la tab Facturas (F15).
        </p>
      )}
    </section>
  );
}
